import { AlertTriangle, CheckCircle2, Info } from "lucide-react";
import { useAnnouncementBanner, type BannerType } from "@/hooks/useSiteSettings";

/**
 * The strip an admin writes in Settings, at the top of every public page.
 *
 * Settings has had an editor for this since the panel was built, with nothing
 * on the site rendering it: switching the banner on saved a row and changed
 * nothing a visitor could see.
 *
 * Nothing renders when the banner is off or its text is blank, so an empty
 * strip can never take up space.
 */
const STYLES: Record<BannerType, { wrap: string; Icon: typeof Info }> = {
  info: { wrap: "bg-primary text-primary-foreground", Icon: Info },
  success: { wrap: "bg-secondary text-secondary-foreground", Icon: CheckCircle2 },
  warning: { wrap: "bg-amber-500 text-amber-950", Icon: AlertTriangle },
};

const AnnouncementBanner = () => {
  const banner = useAnnouncementBanner();
  if (!banner) return null;

  const { wrap, Icon } = STYLES[banner.type];

  return (
    <div role="status" className={`w-full px-4 py-2 text-center text-sm font-medium ${wrap}`}>
      <span className="mx-auto flex max-w-4xl items-center justify-center gap-2">
        <Icon size={15} className="shrink-0" aria-hidden="true" />
        <span>{banner.text}</span>
      </span>
    </div>
  );
};

export default AnnouncementBanner;
